import React from "react";
import { links, copyright } from "constants/footer";

import { DefaultFooter } from "@ant-design/pro-layout";

const Footer: React.FC = () => (
  <DefaultFooter links={links} copyright={copyright} />
);

export default Footer;
